import { ca } from '@cian/analytics';

import { EComparisonToastCategory } from '../../types/comparisonToast';

interface ITrackClickComparisonPopupParams {
  newbuildingId: number;
  category?: EComparisonToastCategory;
}

/**
 * Клик по ссылке «Посмотреть» в тосте сравнения ЖК.
 * `click_popup_add` — тост после добавления, `click_popup_remove` — после удаления.
 */
export function trackClickComparisonPopup({ newbuildingId, category }: ITrackClickComparisonPopupParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: `click_popup_${normalizeCategory(category)}`,
    label: 'to_compare',
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    /**
     * По спеке у CompareJK на карте pageType — 'Map', listingType — 'map' (сайдбар на карте).
     * Передаём page явно: обёртка ensurePageCa добавляет listingType: 'map' и вливает extra
     * карты только тем событиям, у которых есть свой page.
     */
    page: { pageType: 'Map', listingType: 'map' },
  });
}

/**
 * Значение приходит из другого мкс через postMessage, поэтому доверять типу нельзя:
 * сводим к whitelist, чтобы не отправить `click_popup_undefined`.
 * При появлении в спеке новых категорий (например `limit`) — расширить.
 */
function normalizeCategory(category?: EComparisonToastCategory): EComparisonToastCategory {
  return category === EComparisonToastCategory.Remove ? EComparisonToastCategory.Remove : EComparisonToastCategory.Add;
}
